import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/site/Logo";

const links = [
  { href: "#services", label: "Services" },
  { href: "#process", label: "Méthode" },
  { href: "#zones", label: "Zones" },
  { href: "#devis", label: "Devis" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-background/80 border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="px-6 sm:px-10 lg:px-16 xl:px-24 h-20 flex items-center justify-between">
        <a href="#top" className="group" data-testid="logo-link">
          <Logo size="md" />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-foreground/80 hover:text-[hsl(var(--accent))] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:0470628055"
            data-testid="header-phone"
            className="flex items-center gap-2 text-sm text-foreground/80 hover:text-[hsl(var(--accent))] transition-colors"
          >
            <Phone className="w-4 h-4" />
            0470 62 80 55
          </a>
          <a href="#devis" className="btn-primary" data-testid="header-cta-devis">Devis gratuit</a>
        </div>

        <button
          className="lg:hidden p-2 text-foreground"
          onClick={() => setOpen(!open)}
          aria-label="menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background/95 backdrop-blur-xl px-6 py-6 space-y-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="block text-base text-foreground/90 hover:text-[hsl(var(--accent))]"
            >
              {l.label}
            </a>
          ))}
          <a href="#devis" onClick={() => setOpen(false)} className="btn-primary w-full" data-testid="mobile-cta-devis">
            Devis gratuit
          </a>
        </div>
      )}
    </header>
  );
}
